module.exports = __webpack_public_path__ + "static/media/CTLI_6-444w.78e0f580.png";